import { useContext, useEffect, useState } from 'react';
import config from '@/config';
import { Article, FAVORITE_KEY } from '@/constants';
import { AppContext } from '@/App.context';

export function useArticle({ id }: ArticleArgs): ArticleResponse {
	const { db } = useContext(AppContext);
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [article, setArticle] = useState<Article | null>(null);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		if (!db) {
			return;
		}

		if (!id) {
			return;
		}

		db.getArticle(`${id}`)
			.then(a => {
				if (!a) {
					setError(new Error('Article not found'));
					return;
				}
				setArticle(a);
			})
			.catch(err => {
				setError(err.message);
			})
			.finally(() => {
				setIsLoading(false);
			});
	}, [db, id]);

	return {
		article,
		isLoading,
		error,
	};
}

interface ArticleArgs {
	id: string | undefined;
}

interface ArticleResponse {
	article: Article | null;
	isLoading: boolean;
	error?: Error | null;
}

export function useFavorites(): FavoritesResponse {
	const [favorites, setFavorites] = useState<Set<number> | null>(null);
	useEffect(() => {
		if (!config.app.favorite) {
			return;
		}
		const favoriteData = localStorage.getItem(FAVORITE_KEY);
		if (!favoriteData) {
			return;
		}

		const data: Array<number> = JSON.parse(favoriteData);
		setFavorites(new Set([...data]));
	}, []);
	return {
		favorites,
		setFavorites: (data: Set<number>) => {
			setFavorites(data);
			localStorage.setItem(FAVORITE_KEY, JSON.stringify([...data]));
		},
	};
}

interface FavoritesResponse {
	favorites: null | Set<number>;
	setFavorites: (value: Set<number>) => void;
}

export function useValidateFavorite(args: ValidateFavoriteProps): void {
	const { id, favorites, onBack } = args;
	useEffect(() => {
		if (!id) {
			return;
		}

		if (!favorites) {
			return;
		}

		const identifier = parseInt(`${id}`, 10);
		console.log(identifier);
		if (!favorites.has(identifier)) {
			onBack();
		}
	}, [id]);
}

interface ValidateFavoriteProps {
	id: string | undefined;
	favorites: null | Set<number>;
	onBack: () => void;
}
